import { Directive, HostListener, OnInit, AfterViewInit, Input, ElementRef, Renderer2, inject } from '@angular/core';
import {untilDestroyed, UntilDestroy} from '@ngneat/until-destroy';

import {HeaderSortService} from './header-sort.service';
import {SortState} from "./models/enums/sort-state.enum";

@UntilDestroy()
@Directive({
    selector: '[appHeaderSort]',
    standalone: false
})
export class HeaderSortDirective implements OnInit, AfterViewInit {
    private readonly elementRef = inject(ElementRef);
    private readonly renderer = inject(Renderer2);
    private readonly headerSortService = inject(HeaderSortService);

    @Input('appHeaderSort')
    public set key(value: string) {
        this._keys = value.split(',');
    }

    private _keys: string[];
    private sortAscending: boolean;
    private currentState = 0;

    ngOnInit() {
        this.headerSortService
            .getHeaderSort()
            .pipe(untilDestroyed(this))
            .subscribe(sortValue => {
                if (sortValue.initialState && (this._keys[0] === sortValue.sortBy || this._keys[1] === sortValue.secondarySortBy)) {
                    this.currentState = sortValue.initialState;
                }
                if (this._keys.includes(sortValue.sortBy)) {
                    this.sortAscending = sortValue.sortAscending;
                    this.renderer.addClass(
                        this.elementRef.nativeElement,
                        this.sortAscending ? 'ascending' : 'descending'
                    );
                    if (!sortValue.initialState) {
                        this.currentState++;
                        if (this.currentState === SortState.RESET_STATE) {
                            this.currentState = SortState.DEFAULT_STATE;
                            this.sortAscending = false;
                            this.renderer.removeClass(this.elementRef.nativeElement, 'ascending');
                            this.renderer.removeClass(this.elementRef.nativeElement, 'descending');
                        }
                    }
                }
            });
    }

    ngAfterViewInit() {
        this.renderer.addClass(this.elementRef.nativeElement, 'sortable');
    }

    @HostListener('click')
    clickEvent() {
        this.headerSortService.setHeaderSort(this._keys[0], !this.sortAscending, this._keys[1], !this.sortAscending);
    }
}
